export default function VolumeIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.52758 3.41575C9.8163 3.55452 9.99992 3.8465 9.99992 4.16684V15.8335C9.99992 16.1538 9.8163 16.4458 9.52758 16.5846C9.23886 16.7234 8.89615 16.6843 8.64601 16.4842L4.7076 13.3335H1.66659C1.20635 13.3335 0.833252 12.9604 0.833252 12.5002V7.50017C0.833252 7.03993 1.20635 6.66684 1.66659 6.66684H4.7076L8.64601 3.51611C8.89615 3.316 9.23886 3.27698 9.52758 3.41575ZM8.33325 5.90069L5.5205 8.1509C5.37274 8.2691 5.18915 8.3335 4.99992 8.3335H2.49992V11.6668H4.99992C5.18915 11.6668 5.37274 11.7312 5.5205 11.8494L8.33325 14.0997V5.90069Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.3018 3.51889C15.6273 3.1935 16.1549 3.19358 16.4803 3.51907C18.1988 5.23807 19.1642 7.56923 19.1642 9.9999C19.1642 12.4306 18.1988 14.7617 16.4803 16.4807C16.1549 16.8062 15.6273 16.8063 15.3018 16.4809C14.9763 16.1555 14.9762 15.6279 15.3016 15.3024C16.7077 13.8959 17.4975 11.9886 17.4975 9.9999C17.4975 8.01117 16.7077 6.10386 15.3016 4.6974C14.9762 4.37192 14.9763 3.84428 15.3018 3.51889ZM12.3601 6.46056C12.6856 6.13517 13.2133 6.13525 13.5386 6.46074C14.476 7.39837 15.0026 8.66992 15.0026 9.99574C15.0026 11.3216 14.476 12.5931 13.5386 13.5307C13.2133 13.8562 12.6856 13.8563 12.3601 13.5309C12.0346 13.2055 12.0346 12.6779 12.36 12.3524C12.9849 11.7273 13.3359 10.8796 13.3359 9.99574C13.3359 9.11186 12.9849 8.26416 12.36 7.63907C12.0346 7.31358 12.0346 6.78595 12.3601 6.46056Z'
        />
      </svg>
    </span>
  );
}
